/*
 * Manager sidebar menüsü. Başlıklar i18n anahtarı (menu.<key>) — Menu.vue'nin
 * translate() fonksiyonu başına "menu." ekler, dolayısıyla burada "manager.xxx".
 * Metinler tr.js / en.js "menu.manager.*" altında (seçili dile göre gelir).
 */
const DocMenuConfig = [
    {
        pages: [
            { heading: "manager.dashboard", route: "/dashboard", fontIcon: "ki-element-11" },
        ],
    },
    {
        heading: "manager.crm",
        route: "/crm",
        pages: [
            { heading: "manager.crmPipeline", route: "/crm", fontIcon: "ki-abstract-26" },
            { heading: "manager.segments", route: "/segments", fontIcon: "ki-filter-tablet" },
            { heading: "manager.customers", route: "/customers", fontIcon: "ki-profile-circle" },
            { heading: "manager.sites", route: "/sites", fontIcon: "ki-abstract-26" },
            { heading: "manager.provisioning", route: "/provisioning", fontIcon: "ki-rocket" },
            { heading: "manager.campaigns", route: "/campaigns", fontIcon: "ki-sms" },
            { heading: "manager.automations", route: "/automations", fontIcon: "ki-technology-4" },
            { heading: "manager.support", route: "/support", fontIcon: "ki-messages" },
        ],
    },
    {
        heading: "manager.packagesSubs",
        route: "/packages",
        pages: [
            { heading: "manager.packages", route: "/packages", fontIcon: "ki-package" },
            { heading: "manager.packageComparison", route: "/package-comparison", fontIcon: "ki-questionnaire-tablet" },
            { heading: "manager.orders", route: "/orders", fontIcon: "ki-handcart" },
            { heading: "manager.subscriptions", route: "/subscriptions", fontIcon: "ki-questionnaire-tablet" },
            { heading: "manager.invoices", route: "/invoices", fontIcon: "ki-bill" },
        ],
    },
    {
        heading: "site.title",
        route: "/site-management",
        pages: [
            { heading: "site.content.media.title", action: "media-manager", fontIcon: "ki-folder" },
            {
                sectionTitle: "site.content.title",
                route: "/site-management/content",
                fontIcon: "ki-screen",
                sub: [
                    { heading: "site.content.themes.title", route: "/site-management/content/themes", fontIcon: "ki-brush" },
                    { heading: "site.content.slider.title", route: "/site-management/content/slider", fontIcon: "ki-picture" },
                    {
                        sectionTitle: "site.content.blog.title",
                        route: "/site-management/content/blog",
                        fontIcon: "ki-note-2",
                        sub: [
                            { heading: "site.content.blog.posts.title", route: "/site-management/content/blog/content", fontIcon: "ki-notepad" },
                            { heading: "site.content.blog.categories.title", route: "/site-management/content/blog/categories", fontIcon: "ki-category" },
                        ],
                    },
                    { heading: "site.content.successStory.title", route: "/site-management/content/success-story", fontIcon: "ki-medal-star" },
                    { heading: "site.content.pages.title", route: "/site-management/content/pages", fontIcon: "ki-document" },
                    { heading: "site.content.faq.title", route: "/site-management/content/faq", fontIcon: "ki-questionnaire-tablet" },
                    { heading: "site.content.forms.title", route: "/site-management/content/forms", fontIcon: "ki-message-text-2" },
                    { heading: "site.content.popup.title", route: "/site-management/content/popup", fontIcon: "ki-notification-status" },
                    { heading: "site.content.seo.title", route: "/site-management/content/seo", fontIcon: "ki-search-list" },
                    { heading: "site.content.links.title", route: "/site-management/content/links", fontIcon: "ki-exit-right-corner" },
                    { heading: "site.content.menus.title", route: "/site-management/content/menus", fontIcon: "ki-burger-menu-2" },
                ],
            },
            {
                sectionTitle: "manager.teamRoles",
                route: "/site-management/administrators",
                fontIcon: "ki-security-user",
                sub: [
                    { heading: "manager.admins", route: "/site-management/administrators/admins", fontIcon: "ki-people" },
                    { heading: "manager.roles", route: "/site-management/administrators/groups", fontIcon: "ki-shield-tick" },
                ],
            },
            { heading: "manager.localization", route: "/site-management/localization", fontIcon: "ki-flag" },
            {
                sectionTitle: "manager.integrations",
                route: "/integrations",
                fontIcon: "ki-technology-3",
                sub: [
                    { heading: "ecommerce.app.market.title", route: "/integrations/market", fontIcon: "ki-shop" },
                    { heading: "ecommerce.app.myApps.title", route: "/integrations/my-apps", fontIcon: "ki-element-8" },
                ],
            },
            { heading: "manager.systemSettings", route: "/site-management/settings", fontIcon: "ki-setting-2" },
            { heading: "manager.activityLog", route: "/activity-log", fontIcon: "ki-time" },
        ],
    },
];

export default DocMenuConfig;
